import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import Swal from "sweetalert2";

class AddIpWhitelist extends Component {
    constructor(props) {
        super(props)
        this.state = {
            rows:[{}],
        }
    }

    handleAdd = () => {
        this.setState({ prosesSimpan: true})
        let form = {
            rows : this.state.rows,
            ip_start : this.props.ip_start,
            ip_end: this.props.ip_end,
        }
        this.props.request("whitelist/add", form, 'POST')
            .then((response) => {
                if (response && response.success) {
                    this.props.changeState({
                        modal_add: false,
                    }, () => this.props.loadData())
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                } else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({ input: "", rows: [{}], ip_start: [], ip_end: '', prosesSimpan: false })
            })
    }

    handleRowChange = (index, field, value) => {
        value = value.replace(/[^0-9.x]/g, "")
        let parts = value.split(".")
        parts = parts.map((part) => part.slice(0, 3)).slice(0, 4)
        let formattedIp = parts.join(".")
        let newRows = [...this.state.rows]
        newRows[index][field] = formattedIp;
        this.setState({ rows: newRows })
    }

    addRow = () => {
        this.setState(prevState => ({
            rows: [...prevState.rows, { ip: '' }]
        }))
    }

    removeRow = () => {
        this.setState(prevState => ({
            rows: prevState.rows.slice(0, -1)
        }))
    }

    render() {
        return (
            <Modal isOpen={this.props.modal_add} toggle={() => this.props.changeState({ modal_add: false })} style={{ maxWidth: "1000px"}} zIndex={999}>
                <ModalHeader className="pengumuman-modal-header" toggle={() => this.props.changeState({ modal_add: false })}>
                    <div className='presensi-modal-title'>Tambah IP Whitelist</div>
                </ModalHeader>
                <ModalBody className="pengumuman-modal-body">
                    <div className="row p-3">
                        <div className="col">
                            <div className="form-group">
                                <label className="pengumuman-label-input" htmlFor="exampleFormControlInput1">
                                    Pilih tipe input IP
                                </label>
                                <select className="form-control fs-14 py-2"
                                        name="input" value={this.state.input}
                                        onChange={(e) => {
                                            const { name, value } = e.target;
                                            this.setState({
                                                [name]: value,
                                            })

                                            if (value === "byone") {
                                                this.props.changeState({
                                                    ip_start    : "",
                                                    ip_end      : ""
                                                });
                                            } else if (value === "range") {
                                                this.setState({
                                                    rows        : [{}],
                                                });
                                            }
                                        }}
                                >
                                    <option value="">Pilih tipe input IP</option>
                                    <option value="byone">input satuan atau wildcard (x)</option>
                                    <option value="range">input rentang</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row p-3">
                        <div className="col">
                            <div className="form-group">
                                {this.state.input === "byone" &&
                                    <>
                                        {this.state.rows.map((row, index) => (
                                            <div key={index}>
                                                <div className="row">
                                                    <div className="col 1 col-md-1">
                                                        <label className="mb-2 pengumuman-label-input">
                                                            IP {index + 1}
                                                        </label>
                                                    </div>
                                                    <div className="col-7 col-md-5">
                                                        <input
                                                            name={`ip_${index}`}
                                                            className="form-control mb-2 py-2"
                                                            style={{fontSize: "12px"}}
                                                            placeholder="Masukkan IP (ex : 192.168.1.x)"
                                                            type="text"
                                                            value={row.ip}
                                                            onChange={(e) => this.handleRowChange(index, 'ip', e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="col-3 col-md-1 p-0">
                                                        {this.state.rows.length !== 1 &&
                                                            <button
                                                                className="btn btn-danger mb-2"
                                                                style={{padding: "7px 24px"}}
                                                                onClick={this.removeRow}>
                                                                <i className="fa fa-trash"></i>
                                                            </button>
                                                        }
                                                        {this.state.rows.length - 1 === index &&
                                                            <button
                                                                className="btn btn-primary"
                                                                style={{padding: "7px 24px"}}
                                                                onClick={this.addRow}>
                                                                <i className="fa fa-plus"></i>
                                                            </button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                }
                                {this.state.input === "range" &&
                                    <>
                                        <div className="row">
                                            <div className="col">
                                                <label className="pengumuman-label-input">
                                                    Dari
                                                </label>
                                                <input type='text' onChange={this.props.handleInputIP}
                                                       name='ip_start' value={this.props.ip_start}
                                                       className='form-control font-12'
                                                       placeholder="Masukkan IP (ex : 192.168.1.x)"/>
                                            </div>
                                            <div className="col">
                                                <label className="pengumuman-label-input">
                                                    Sampai
                                                </label>
                                                <input type='text' onChange={this.props.handleInputIP}
                                                       name='ip_end' value={this.props.ip_end}
                                                       className='form-control font-12'
                                                       placeholder="Masukkan IP (ex : 192.168.1.x)"/>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="pengumuman-modal-footer">
                    <button onClick={() => this.props.changeState({modal_add: false})}
                            className='btn text-capitalize batalkan-add-jamker'>Batal</button>
                    <button className='btn btn-primary text-capitalize' disabled={this.state.prosesSimpan}
                            style={{padding: "8px 14px", fontWeight: 500, fontSize: "14px", lineHeight: "24px"}}
                            onClick={this.handleAdd}>{this.state.prosesSimpan ? "Menyimpan" : "Simpan"}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default AddIpWhitelist;